import React, { createContext, useContext, useState, ReactNode } from "react";

interface RouteContextType {
  currentPath: string;
  setCurrentPath: (path: string) => void;
  onePageBasePath: string;
  setOnePageBasePath: (path: string) => void;
}

const RouteContext = createContext<RouteContextType | undefined>(undefined);

export const AppRouteProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [currentPath, setCurrentPath] = useState<string>("");
  const [onePageBasePath, setOnePageBasePath] = useState("");

  return (
    <RouteContext.Provider
      value={{
        currentPath,
        setCurrentPath,
        onePageBasePath,
        setOnePageBasePath,
      }}
    >
      {children}
    </RouteContext.Provider>
  );
};

export const useAppRouteContext = () => {
  const context = useContext(RouteContext);
  if (!context) {
    throw new Error(
      "useAppRouteContext must be used within a AppRouteProvider",
    );
  }
  return context;
};
